import React, { useState } from "react";
import PropTypes from "prop-types";

const ArrowWithLine = ({ color, onClick }) => {
  //   const [color, setColor] = useState(initialColor);

  const lineStyle = {
    height: "6px",
    backgroundColor: color,
    flex: 1,
  };

  const arrowStyle = {
    border: `solid ${color}`,
    borderWidth: "0 4px 4px 0",
    display: "inline-block",
    padding: "4px",
    transform: "rotate(-45deg)",
    marginLeft: "-6px",
  };

  const containerStyle = {
    display: "flex",
    alignItems: "center",
  };

  // 方法来更改箭头颜色
  //   const changeColor = (newColor) => {
  //     setColor(newColor);
  //   };

  // 现在箭头颜色是基于state的，并且可以通过changeColor方法改变
  return (
    <div style={containerStyle} onClick={onClick}>
      <div style={lineStyle} />
      <div style={arrowStyle} />
      {/* 可以在这里添加一个按钮来触发颜色的更改 */}
      {/* <button onClick={() => changeColor('yourNewColorHere')}>Change Color</button> */}
    </div>
  );
};

ArrowWithLine.propTypes = {
  color: PropTypes.string,
};

ArrowWithLine.defaultProps = {
  color: "black", // 默认颜色
};

export default ArrowWithLine;
